// apps/client/src/ui/kit/Panel.tsx — a frame that holds the title tab, around a body that scrolls (the tab is never clipped)
import type { ReactNode } from 'react';
import { TitleTab } from './TitleTab';
export function Panel(p: { title?: string; tabColor?: string; className?: string; children: ReactNode }) {
  return (
    <section className="panel-frame hit">
      {p.title !== undefined && <TitleTab color={p.tabColor}>{p.title}</TitleTab>}
      <div className={`panel ${p.className ?? ''}`}>{p.children}</div>
    </section>
  );
}
